/**
 * External Dependencies
 */
import 'jquery';
import MobileMenu from './modules/MobileMenu';
import ClickDropdownMenu from './modules/ClickDropdownMenu';

$(document).ready(() => {
	new ClickDropdownMenu('#mobile-menu');
	new MobileMenu({
		menu: '#mobile-menu',
		button: '#mobile-menu-toggle',
		closeArea: '#mobile-menu-close',
		desktopMenu: '#desktop-menu',
	});

	/* set tabIndex to 0 on all a tags that are children of elements
	 * with the menuitem class for Safari
	 * facilitates :focus states for the a tags
	 */
	/*
	var menuitems = document.getElementsByClassName('menu-item');
	for (var i = 0; i < menuitems.length; i++) {
		var anchors = menuitems[i].getElementsByTagName('a');
		for (var j = 0; j < anchors.length; j++) {
			anchors[j].tabIndex = 0;
		}
	}
	*/

	/* show mobile nav when the hamberger button is clicked */
	/*
	document.querySelector(".header-menu-button").addEventListener("click", (e) => {
		e.preventDefault();
		document.getElementById("mobile-menu-backdrop").classList.remove("hidden");
		//mmenu.API.open();
	});

	/* hid the mobile nav if the shadowbox (but not its children) is clicked */
	/*
	var mmbackdrop = document.getElementById("mobile-menu-backdrop");
	mmbackdrop.addEventListener("click", (e) => {
		if (mmbackdrop === e.target) {
			document.getElementById("mobile-menu-backdrop").classList.add("hidden");
			//mmenu.API.close();
		}
	});
	*/


  // accessibility
  $('.mm-menu').find('.mm-tabstart').text('Beginning of menu');
  $('.mm-menu').find('.mm-tabend').text('End of menu');
  $('.mm-slideout').find('.mm-tabend').text('End of slideout');

  // Make entire cards clickable
  const cards = document.querySelectorAll('.card');
  Array.prototype.forEach.call(cards, card => {
    let down, up, link = card.querySelector('.card-link');
    card.onmousedown = () => down = +new Date();
    card.onmouseup = () => {
      up = +new Date();
      if ((up - down) < 200) {
        link.click();
      }
    }
    card.style.cursor = 'pointer';
  });

  // forms
  function checkForm() {
    if ($(this).val().trim() == '') {
      $(this).parent().addClass('form-is-empty');
      $(this).parents('.gfield').addClass('form-is-empty');
    }

    else {
      $(this).parent().removeClass('form-is-empty');
      $(this).parents('.gfield').removeClass('form-is-empty');
    }
  }
  $('input').add('textarea').blur(checkForm).each(checkForm);

  // tabbing
  // @link https://medium.com/hackernoon/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2
  function handleFirstTab(e) {
    if (e.keyCode === 9) {
      document.body.classList.add('user-is-tabbing');
      document.querySelector('#app').children[0].classList.add('user-is-tabbing');

      window.removeEventListener('keydown', handleFirstTab);
      window.addEventListener('mousedown', handleMouseDownOnce);
    }
  }

  function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    document.querySelector('#app').children[0].classList.remove('user-is-tabbing');

    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
  }

  window.addEventListener('keydown', handleFirstTab);

  //prevent jump to top on desktop menu click
  $('li.menu-item-has-children > a').click(function(e) {
    // Cancel the default action
    e.preventDefault();
  });
});
